import { PipeTransform, Pipe } from '@angular/core';
import { ExecutionModeEnum } from '@app/core/services/financial-engine/models/enum/executionMode.enum';

@Pipe({name: 'executionMode'})
export class ExecutionModePipe implements PipeTransform {
  transform(value: ExecutionModeEnum): string {
    return value === ExecutionModeEnum.TAP_INITIATED ? "TapInitiated" : value;
  }
}
